import { BeconAccountTypes, BeconCommonTypes, BeconUserTypes } from "@becon-team/becon-fe-lib/my-types";
import { z } from "zod";

import { UserDtoSchema, UserItemDtoSchema, UserInquiryDtoSchema, UserHealthInquiryDtoSchema } from "./user.dto";

// *정책: `privacyTerm`, `sensitivityTerm`, `serviceTerm`은 API에는 포함이나 정책상 제외
/** PUT: 유저 정보 수정 */
export const PutUserRequestSchema = z.object({
  userId: z.string(),
  assignedAccountId: z.string().nullable(),
  nickname: z.string(),
  phoneNumber: z.string(),
  gender: z.nativeEnum(BeconUserTypes.UserGenderEnum),
  birth: z.string(),
  marketingAgreement: z.boolean(),
  memo: z.string().nullable(),
});
export type PutUserRequest = z.infer<typeof PutUserRequestSchema>;

export interface PutUser {
  (arg: PutUserRequest): Promise<unknown>;
}

/** DELETE: 유저 삭제 */
export interface DeleteUser {
  (arg: { userId: string }): Promise<unknown>;
}

/** GET: 유저 조회 */
export const GetUserRequestSchema = z.object({
  userId: z.string(),
});
export type GetUserRequest = z.infer<typeof GetUserRequestSchema>;

export const GetUserResponseSchema = UserDtoSchema;
export type GetUserResponse = z.infer<typeof GetUserResponseSchema>;

export interface GetUser {
  (arg: GetUserRequest): Promise<GetUserResponse>;
}

/** GET: 유저 문진 조회 */
export const GetUserInquiryResponseSchema = z.object({
  user_id: z.string(),
  inquiry: UserInquiryDtoSchema.nullable(),
});
export type GetUserInquiryResponse = z.infer<typeof GetUserInquiryResponseSchema>;

export interface GetUserInquiry {
  (arg: { userId: string }): Promise<GetUserInquiryResponse>;
}

export interface GetUserInquiry {
  (arg: { userId: string }): Promise<GetUserInquiryResponse>;
}

/** PUT: 유저 문진 수정 */
export const PutUserInquiryRequestSchema = z.object({
  gender: z.nativeEnum(BeconUserTypes.UserGenderEnum),
  ageGroup: z.nativeEnum(BeconUserTypes.AgeGroupEnum),
  skinColor: UserInquiryDtoSchema.shape.skin_color.optional(),
  scalpIssues: UserInquiryDtoSchema.shape.scalp_issues.optional(),
  hairlossType: UserInquiryDtoSchema.shape.hairloss_type.optional(),
  hairlossLevel: UserInquiryDtoSchema.shape.hairloss_level.optional(),
  hairlossFamilyHistory: UserInquiryDtoSchema.shape.hairloss_family_history.optional(),
  hairType: UserInquiryDtoSchema.shape.hair_type.optional(),
  hairColor: UserInquiryDtoSchema.shape.hair_color.optional(),
  hairDamageLevel: UserInquiryDtoSchema.shape.hair_damage_level.optional(),
  lifestyle: z.object({
    dyeing: UserInquiryDtoSchema.shape.lifestyle.shape.dyeing.optional(),
    perm: UserInquiryDtoSchema.shape.lifestyle.shape.perm.optional(),
    wash_hair_cycle: UserInquiryDtoSchema.shape.lifestyle.shape.wash_hair_cycle.optional(),
    treatment_product: UserInquiryDtoSchema.shape.lifestyle.shape.treatment_product.optional(),
  }),
  preference: z.object({
    shampoo_1: UserInquiryDtoSchema.shape.preference.shape.shampoo_1.optional(),
    shampoo_2: UserInquiryDtoSchema.shape.preference.shape.shampoo_2.optional(),
    hair_1: UserInquiryDtoSchema.shape.preference.shape.hair_1.optional(),
  }),
});
export type PutUserInquiryRequest = z.infer<typeof PutUserInquiryRequestSchema>;

export interface PutUserInquiry {
  (arg: { userId: string } & PutUserInquiryRequest): Promise<unknown>;
}

/** GET: 유저 건강 문진 조회 */
export const GetUserHealthInquiryResponseSchema = z.object({
  healthInquiry: z
    .object({
      diet: UserHealthInquiryDtoSchema.shape.diet.optional().nullable(),
      smoking: UserHealthInquiryDtoSchema.shape.smoking.optional().nullable(),
      coffee: UserHealthInquiryDtoSchema.shape.coffee.optional().nullable(),
      drinking: UserHealthInquiryDtoSchema.shape.drinking.optional().nullable(),
      work_out: UserHealthInquiryDtoSchema.shape.work_out.optional().nullable(),
      sleep_time: UserHealthInquiryDtoSchema.shape.sleep_time.optional().nullable(),
      stress_level: UserHealthInquiryDtoSchema.shape.stress_level.optional().nullable(),
    })
    .nullable(),
});
export type GetUserHealthInquiryResponse = z.infer<typeof GetUserHealthInquiryResponseSchema>;

export interface GetUserHealthInquiry {
  (arg: { userId: string }): Promise<GetUserHealthInquiryResponse>;
}

/** POST: 유저 겅강 문진 등록 */
export const PostUserHealthInquiryRequestSchema = z.object({
  diet: UserHealthInquiryDtoSchema.shape.diet.optional(),
  smoking: UserHealthInquiryDtoSchema.shape.smoking.optional(),
  coffee: UserHealthInquiryDtoSchema.shape.coffee.optional(),
  drinking: UserHealthInquiryDtoSchema.shape.drinking.optional(),
  work_out: UserHealthInquiryDtoSchema.shape.work_out.optional(),
  sleep_time: UserHealthInquiryDtoSchema.shape.sleep_time.optional(),
  stress_level: UserHealthInquiryDtoSchema.shape.stress_level.optional(),
});
export type PostUserHealthInquiryRequest = z.infer<typeof PostUserHealthInquiryRequestSchema>;

export interface PostUserHealthInquiry {
  (arg: { userId: string } & PostUserHealthInquiryRequest): Promise<unknown>;
}
